module.exports = __webpack_public_path__ + "img/SaudiCoupons.bfebcabe.svg";